import { EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { FOLDERABLE_APP_CONFIG, IS_MODAL_VIEW } from 'FoldersApp/constants/folderable-app-config.constants';
import { FolderableOperationValue } from 'FoldersApp/state/folderable-operation/folderable-operation-value.enum';
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { BulkActionSelectionService } from 'FoldersApp/services/bulk-action-selection.service';
import { FolderableCollectionLoadOnScrollServiceBase } from 'FoldersApp/services/folderable-collection-load-on-scroll-service-base.service';
import { FolderableCollectionServiceBase } from 'FoldersApp/services/folderable-collection-service-base.service';
import { SelectedFolderableService } from 'FoldersApp/services/selected-folderable.service';
import { ItemSelectionService } from 'NewAngular/services/item-selection.service';
import { FolderableSavedModalBaseDirective } from './folderable-saved-base.directive';
import * as i0 from "@angular/core";
import * as i1 from "AccountsApp/ts/services/accounts.service";
import * as i2 from "FoldersApp/services/bulk-action-selection.service";
import * as i3 from "FoldersApp/services/folderable-collection-load-on-scroll-service-base.service";
import * as i4 from "FoldersApp/services/selected-folderable.service";
import * as i5 from "@ngrx/store";
import * as i6 from "NewAngular/services/item-selection.service";
import * as i7 from "@angular/common";
import * as i8 from "@angular/forms";
import * as i9 from "../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i10 from "../../../../../../ycharts/static/ts/features/directives/infinite-scroll/infinite-scroll.directive";
import * as i11 from "../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
import * as i12 from "../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i13 from "../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-footer.component";
import * as i14 from "../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i15 from "FoldersApp/features/folders-shared/folderable-bulk-action-menu/folderable-bulk-action-menu.component";
import * as i16 from "FoldersApp/features/folders-shared/folderable-column-headers-component/folderable-column-headers.component";
import * as i17 from "FoldersApp/features/folders-shared/folderable-open-saved-filter/folderable-open-saved-filter.component";
import * as i18 from "FoldersApp/features/folders-shared/folderable-move-modal/folderable-move-modal.component";
import * as i19 from "FoldersApp/features/folders-shared/folder-breadcrumb/folder-breadcrumb.component";
const _c0 = a0 => ({ "visibility": a0 });
const _c1 = (a0, a1, a2) => ({ id: a0, name: a1, permissions: a2 });
const _c2 = (a0, a1) => ({ folderable: a0, ancestorInfo: a1 });
function _forTrack0($index, $item) { return this.trackFolderable($item); }
function FolderableSingleSelectSavedModalComponent_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-folderable-open-saved-filter", 3);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("publicSharing", ctx_r0.publicSharing)("maxLength", ctx_r0.maxLength);
} }
function FolderableSingleSelectSavedModalComponent_Conditional_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtext(1, "Search Results");
    i0.ɵɵelementEnd();
} }
function FolderableSingleSelectSavedModalComponent_Conditional_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-folder-breadcrumb", 7);
} if (rf & 2) {
    i0.ɵɵproperty("displayFlex", false);
} }
function FolderableSingleSelectSavedModalComponent_Conditional_12_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 23);
    i0.ɵɵlistener("click", function FolderableSingleSelectSavedModalComponent_Conditional_12_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.searchTermInput.setValue("")); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-close");
} }
function FolderableSingleSelectSavedModalComponent_Conditional_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 12);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-search");
} }
function FolderableSingleSelectSavedModalComponent_Conditional_19_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 26);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.columnHeaderTrailingFragment);
} }
function FolderableSingleSelectSavedModalComponent_Conditional_19_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 27);
} }
function FolderableSingleSelectSavedModalComponent_Conditional_19_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵlistener("setSort", function FolderableSingleSelectSavedModalComponent_Conditional_19_Template_div_setSort_0_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.setSort($event)); });
    i0.ɵɵconditionalCreate(1, FolderableSingleSelectSavedModalComponent_Conditional_19_Conditional_1_Template, 1, 1, "ng-container", 26)(2, FolderableSingleSelectSavedModalComponent_Conditional_19_Conditional_2_Template, 1, 0, "div", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("columnConfig", ctx_r0.columnConfig)("sortableColumns", ctx_r0.sortableColumns)("sortColumn", ctx_r0.folderableCollectionService.dataParams.sortColumn)("sortDirection", ctx_r0.folderableCollectionService.dataParams.sortDirection);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.columnHeaderTrailingFragment ? 1 : 2);
} }
function FolderableSingleSelectSavedModalComponent_Conditional_21_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28)(1, "span");
    i0.ɵɵtext(2, "There are no items.");
    i0.ɵɵelementEnd()();
} }
function FolderableSingleSelectSavedModalComponent_Conditional_21_Conditional_1_For_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 29);
} if (rf & 2) {
    const folderable_r4 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.listItemFragment)("ngTemplateOutletInjector", ctx_r0.injector)("ngTemplateOutletContext", i0.ɵɵpureFunction2(7, _c2, folderable_r4, i0.ɵɵpureFunction3(3, _c1, ctx_r0.folderableCollectionService.viewRootFolder.id, ctx_r0.folderableCollectionService.viewRootFolder.name, ctx_r0.folderableCollectionService.viewRootFolder.permissions)));
} }
function FolderableSingleSelectSavedModalComponent_Conditional_21_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, FolderableSingleSelectSavedModalComponent_Conditional_21_Conditional_1_For_1_Template, 1, 10, "ng-container", 29, _forTrack0, true);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵrepeater(ctx_r0.folderableCollectionService.items);
} }
function FolderableSingleSelectSavedModalComponent_Conditional_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵconditionalCreate(0, FolderableSingleSelectSavedModalComponent_Conditional_21_Conditional_0_Template, 3, 0, "div", 28)(1, FolderableSingleSelectSavedModalComponent_Conditional_21_Conditional_1_Template, 2, 0);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(!ctx_r0.folderableCollectionService.loading && ctx_r0.folderableCollectionService.items.length === 0 ? 0 : 1);
} }
function FolderableSingleSelectSavedModalComponent_Conditional_22_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 30);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", ctx_r0.userHasNoDataMessage, i0.ɵɵsanitizeHtml);
} }
function FolderableSingleSelectSavedModalComponent_Conditional_22_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵtext(1, " No Results.");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementStart(3, "span")(4, "a", 32);
    i0.ɵɵlistener("click", function FolderableSingleSelectSavedModalComponent_Conditional_22_Conditional_1_Template_a_click_4_listener() { i0.ɵɵrestoreView(_r5); const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.clearFilters()); });
    i0.ɵɵtext(5, "Clear Filters");
    i0.ɵɵelementEnd()()();
} }
function FolderableSingleSelectSavedModalComponent_Conditional_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵconditionalCreate(0, FolderableSingleSelectSavedModalComponent_Conditional_22_Conditional_0_Template, 1, 1, "div", 30)(1, FolderableSingleSelectSavedModalComponent_Conditional_22_Conditional_1_Template, 6, 0, "div", 31);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.folderableCollectionService.userHasNoData ? 0 : 1);
} }
function FolderableSingleSelectSavedModalComponent_Conditional_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol", 18);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("loaderMessage", ctx_r0.loadingMessage);
    i0.ɵɵattribute("data-test-id", ctx_r0.loadingTestId);
} }
function FolderableSingleSelectSavedModalComponent_Conditional_24_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵlistener("fetchMoreItemsHandler", function FolderableSingleSelectSavedModalComponent_Conditional_24_Template_div_fetchMoreItemsHandler_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.folderableCollectionService.loadItems(true, true)); });
    i0.ɵɵelementEnd();
} }
function FolderableSingleSelectSavedModalComponent_Conditional_26_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-simple-modal-footer", 34);
    i0.ɵɵlistener("cancelHandler", function FolderableSingleSelectSavedModalComponent_Conditional_26_Template_ycn_simple_modal_footer_cancelHandler_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.cancel()); })("secondaryHandler", function FolderableSingleSelectSavedModalComponent_Conditional_26_Template_ycn_simple_modal_footer_secondaryHandler_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.back()); })("submitHandler", function FolderableSingleSelectSavedModalComponent_Conditional_26_Template_ycn_simple_modal_footer_submitHandler_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.submit()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("modalTestId", "edit-talking-points-modal")("disableSubmission", !ctx_r0.selectedItems.length)("selectedItemCount", ctx_r0.isMultiSelect ? ctx_r0.selectedItems.length : undefined)("showSubmitButton", ctx_r0.isMultiSelect)("secondaryButtonText", ctx_r0.showBackButton ? "Back" : undefined)("secondaryButtonClasses", "btn-secondary");
} }
function FolderableSingleSelectSavedModalComponent_Conditional_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 22);
} }
/**
 * Modal for selecting a single folderable item.
 * - When a non-folder is clicked, that item is selected and the modal closes.
 *
 * Usage:
 * - The parent component is responsible for handling the selection.
 *   This is done by attaching a handler to this component's `selectionHandler` output binding.
 *   Ex: <ycn-folderable-single-select-saved-modal [selection]=handleSelection($event)></ycn-folderable-single-select-saved-modal>
 *
 * - The component rendered in `listItemFragment` should use an instance of `ItemSelectionService`
 *   to select an item.
 */
export class FolderableSingleSelectSavedModalComponent extends FolderableSavedModalBaseDirective {
    constructor(accountsService, 
    // The bulkActionSelectionService is not used by this component. We inject it here because the component shares
    // a template with a component that does use this service.
    // We should look into how to better separate these dependencies.
    bulkActionSelectionService, folderableAppConfig, folderableCollectionService, selectedFolderableService, store, itemSelectionService) {
        super(accountsService, folderableAppConfig, folderableCollectionService, selectedFolderableService, store);
        this.accountsService = accountsService;
        this.bulkActionSelectionService = bulkActionSelectionService;
        this.folderableAppConfig = folderableAppConfig;
        this.folderableCollectionService = folderableCollectionService;
        this.selectedFolderableService = selectedFolderableService;
        this.store = store;
        this.itemSelectionService = itemSelectionService;
        this.selectionHandler = new EventEmitter();
        this.folderableOperationValue = FolderableOperationValue.SINGLE_SELECT;
    }
    ngOnInit() {
        super.ngOnInit();
        this.itemSelectionService.items$.subscribe((selections) => {
            const values = Object.values(selections);
            this.selectedItems = values;
            if (values.length === 0)
                return;
            if (values.length > 1) {
                throw new Error(`Only one item can be selected. There were ${values.length} selected items`);
            }
            this.selectionHandler.emit(values[0]);
            this.close();
        });
    }
    close() {
        super.close();
        this.itemSelectionService.clearSelections();
    }
}
FolderableSingleSelectSavedModalComponent.ɵfac = function FolderableSingleSelectSavedModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FolderableSingleSelectSavedModalComponent)(i0.ɵɵdirectiveInject(i1.AccountsService), i0.ɵɵdirectiveInject(i2.BulkActionSelectionService), i0.ɵɵdirectiveInject(FOLDERABLE_APP_CONFIG), i0.ɵɵdirectiveInject(i3.FolderableCollectionLoadOnScrollServiceBase), i0.ɵɵdirectiveInject(i4.SelectedFolderableService), i0.ɵɵdirectiveInject(i5.Store), i0.ɵɵdirectiveInject(i6.ItemSelectionService)); };
FolderableSingleSelectSavedModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FolderableSingleSelectSavedModalComponent, selectors: [["ycn-folderable-single-select-saved-modal"]], outputs: { selectionHandler: "selectionHandler" }, standalone: false, features: [i0.ɵɵProvidersFeature([
            { provide: FolderableCollectionLoadOnScrollServiceBase, useExisting: FolderableCollectionServiceBase },
            { provide: IS_MODAL_VIEW, useValue: true },
        ]), i0.ɵɵInheritDefinitionFeature], decls: 28, vars: 21, consts: [[3, "closeModalHandler", "modalBaseClass", "open"], [3, "closeModalHandler", "header", "showUnsavedStatus"], [1, "modal-body", 2, "padding", "0"], [3, "publicSharing", "maxLength"], [1, "modal-section"], [1, "mt-2", "mb-12", "d-flex", "align-items-center"], [1, "text-bold"], [3, "displayFlex"], [1, "width-180", "ml-auto"], [1, "field-input-group", "field-search", "input-group"], ["placeholder", "Search Folder or File", "data-test-id", "name_filter_input", 1, "form-control", "field-input", 3, "formControl"], [1, "field-input-group-actions"], [1, "btn", "btn-transparent"], [1, "bg-yc-blue-75", 3, "ngStyle"], [1, "page-progress-bar"], [1, "table", "table-airy", "table-hover", "file-table", "overflow-auto", 3, "id"], ["ycn-folderable-column-headers", "", 1, "thead", 3, "columnConfig", "sortableColumns", "sortColumn", "sortDirection"], [1, "tbody"], [3, "loaderMessage"], ["ycnInfiniteScroll", ""], [2, "z-index", "10000"], [3, "modalTestId", "disableSubmission", "selectedItemCount", "showSubmitButton", "secondaryButtonText", "secondaryButtonClasses"], [1, "modal-footer", "border-0"], [1, "btn", "btn-transparent", 3, "click"], ["ycnIcon", "", 3, "name"], ["ycn-folderable-column-headers", "", 1, "thead", 3, "setSort", "columnConfig", "sortableColumns", "sortColumn", "sortDirection"], [3, "ngTemplateOutlet"], [1, "th", "col-1"], [1, "get-started-small", "flex-auto"], [3, "ngTemplateOutlet", "ngTemplateOutletInjector", "ngTemplateOutletContext"], [1, "get-started", "flex-auto", 3, "innerHTML"], [1, "get-started", "flex-auto", "min-height-220"], ["href", "javascript:void(0)", 1, "text-blue", 3, "click"], ["ycnInfiniteScroll", "", 3, "fetchMoreItemsHandler"], [3, "cancelHandler", "secondaryHandler", "submitHandler", "modalTestId", "disableSubmission", "selectedItemCount", "showSubmitButton", "secondaryButtonText", "secondaryButtonClasses"]], template: function FolderableSingleSelectSavedModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 0);
        i0.ɵɵlistener("closeModalHandler", function FolderableSingleSelectSavedModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.cancel(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 1);
        i0.ɵɵlistener("closeModalHandler", function FolderableSingleSelectSavedModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.cancel(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵconditionalCreate(3, FolderableSingleSelectSavedModalComponent_Conditional_3_Template, 1, 2, "ycn-folderable-open-saved-filter", 3);
        i0.ɵɵelementStart(4, "div", 4)(5, "div", 5);
        i0.ɵɵconditionalCreate(6, FolderableSingleSelectSavedModalComponent_Conditional_6_Template, 2, 0, "div", 6)(7, FolderableSingleSelectSavedModalComponent_Conditional_7_Template, 1, 1, "ycn-folder-breadcrumb", 7);
        i0.ɵɵelementStart(8, "div", 8)(9, "div", 9);
        i0.ɵɵelement(10, "input", 10);
        i0.ɵɵelementStart(11, "div", 11);
        i0.ɵɵconditionalCreate(12, FolderableSingleSelectSavedModalComponent_Conditional_12_Template, 2, 1, "button", 12)(13, FolderableSingleSelectSavedModalComponent_Conditional_13_Template, 2, 1, "button", 12);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(14, "div", 13);
        i0.ɵɵelement(15, "div", 14);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(16, "ycn-folderable-bulk-action-menu");
        i0.ɵɵelementStart(17, "div", 15);
        i0.ɵɵpipe(18, "async");
        i0.ɵɵconditionalCreate(19, FolderableSingleSelectSavedModalComponent_Conditional_19_Template, 3, 5, "div", 16);
        i0.ɵɵelementStart(20, "div", 17);
        i0.ɵɵconditionalCreate(21, FolderableSingleSelectSavedModalComponent_Conditional_21_Template, 2, 1)(22, FolderableSingleSelectSavedModalComponent_Conditional_22_Template, 2, 1);
        i0.ɵɵconditionalCreate(23, FolderableSingleSelectSavedModalComponent_Conditional_23_Template, 1, 2, "ycn-loading-symbol", 18)(24, FolderableSingleSelectSavedModalComponent_Conditional_24_Template, 1, 0, "div", 19);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelement(25, "ycn-folderable-move-modal", 20);
        i0.ɵɵelementEnd();
        i0.ɵɵconditionalCreate(26, FolderableSingleSelectSavedModalComponent_Conditional_26_Template, 1, 6, "ycn-simple-modal-footer", 21);
        i0.ɵɵconditionalCreate(27, FolderableSingleSelectSavedModalComponent_Conditional_27_Template, 1, 0, "div", 22);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("modalBaseClass", "modal-fix-scroll")("open", ctx.isOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", ctx.modalHeader)("showUnsavedStatus", false);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.folderableCollectionService.dataParams ? 3 : -1);
        i0.ɵɵadvance(3);
        i0.ɵɵconditional(ctx.folderableCollectionService.textSearchActive ? 6 : 7);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("formControl", ctx.searchTermInput);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.searchTermInput.value ? 12 : 13);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(19, _c0, ctx.folderableCollectionService.loading ? "visible" : "hidden"));
        i0.ɵɵadvance(3);
        i0.ɵɵclassProp("multiselect", i0.ɵɵpipeBind1(18, 17, ctx.bulkActionSelectionService.bulkActionMode$));
        i0.ɵɵproperty("id", ctx.folderableCollectionService.scrollableBodyId);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.folderableCollectionService.dataParams ? 19 : -1);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.folderableCollectionService.viewRootFolder && ctx.folderableCollectionService.items ? 21 : !ctx.folderableCollectionService.loading ? 22 : -1);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.folderableCollectionService.showLoading && ctx.folderableCollectionService.loading ? 23 : (ctx.folderableCollectionService.paginationInfo == null ? null : ctx.folderableCollectionService.paginationInfo.current_page_num) !== (ctx.folderableCollectionService.paginationInfo == null ? null : ctx.folderableCollectionService.paginationInfo.num_pages) ? 24 : -1);
        i0.ɵɵadvance(3);
        i0.ɵɵconditional(ctx.isMultiSelect || ctx.showBackButton ? 26 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.footerSpacer() ? 27 : -1);
    } }, dependencies: [i7.NgTemplateOutlet, i7.NgStyle, i8.DefaultValueAccessor, i8.NgControlStatus, i9.IconDirective, i10.InfiniteScrollDirective, i11.LoadingSymbolComponent, i12.ModalBaseComponent, i13.SimpleModalFooterComponent, i14.SimpleModalHeaderComponent, i8.FormControlDirective, i15.FolderableBulkActionMenuComponent, i16.FolderableColumnHeadersComponent, i17.FolderableOpenSavedFilterComponent, i18.FolderableMoveModalComponent, i19.FolderBreadcrumbComponent, i7.AsyncPipe], encapsulation: 2 });
